import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'

import oauth from './oauth'
import cart from './cart'
import search from './order-search'
import edit from './order-edit'
import config from './config'
import prefs from './prefs'
import report from './report'
import baseinfo from './baseinfo-edit'

import {
  getAccounts,
  getBrands,
  getWarehouses,
  getStaff,
  getAreaTypes,
  getPaymentTypes,
  getPrintInfo,
  getCsrSelfOrderCnt
} from '../api'

import {
  routeINV,
  routeCN,
  routePO,
  routeBCN,
  routeBL,
  routeTR,
  routeAJ,
  routeInfoPRDC,
  routeInfoCSR,
  routeInfoSPL,
  routeInfoWH,
  routeInfoBRD,
  routeInfoEMPL
} from '../router'

moment.locale('en-au')

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  modules: {
    oauth,
    cart,
    search,
    edit,
    config,
    prefs,
    report,
    baseinfo
  },
  state: {
    printInfo: {
      name: '',
      logo: '',
      addressLine1: '',
      addressLine2: '',
      phone: '',
      email: '',
      website: '',
      bankAccount: '',
      bsb: '',
      bankAccountName: '',
      anb: ''
    },
    csrSelfOrderCnt: 0,
    currentAccount: {},
    accounts: [],
    brands: [],
    warehouses: [],
    areaTypes: [],
    paymentTypes: [],
    categories: [
      { value: 1, label: 'Tyres' },
      { value: 2, label: 'Auto Parts' },
      { value: 3, label: 'Gifts Others' },
      { value: 4, label: 'Services' }
    ],
    stockAvl: [
      { value: 1, label: 'In Stock Only' },
      { value: 2, label: 'Out of Stock' },
      { value: 5, label: 'No More Than 5' },
      { value: 8, label: 'No More Than 8' },
      { value: 10, label: 'No More Than 10' },
      { value: 15, label: 'No More Than 15' },
      { value: 20, label: 'No More Than 20' },
      { value: 25, label: 'No More Than 25' }
    ],
    materials: [
      { value: 1, label: 'N/A' },
      { value: 2, label: 'Alloy' },
      { value: 3, label: 'Steel' }
    ],
    staff: [],
    tags: [
      { value: 1, label: 'Normal' },
      { value: 3, label: 'Special Sale' },
      { value: 2, label: 'Adjustment' },
      { value: 4, label: 'Giftware' },
      { value: 5, label: 'Outsourcing' }
    ],
    orderTypes: [
      { value: 1, label: 'Invoice' },
      { value: 2, label: 'Credit Note' },
      { value: 3, label: 'Purchase Order' },
      { value: 4, label: 'Bill' },
      { value: 5, label: 'Bill Credit Note' },
      { value: 6, label: 'Transfer' },
      { value: 7, label: 'Adjustment' }
    ],
    orderStatus: [
      { value: 1, label: 'Draft' },
      { value: 2, label: 'Approved' },
      { value: 3, label: 'Voided' },
      { value: 4, label: 'Closed' }
    ],
    drafterType: [
      { value: 0, label: 'All' },
      { value: 1, label: 'Staff' },
      { value: 2, label: 'Staff' },
      { value: 3, label: 'Customer' }
    ],
    drafterTypeColumn: [
      { value: 0, label: 'Admin' },
      { value: 1, label: 'Staff' },
      { value: 2, label: 'Staff' },
      { value: 3, label: 'Customer' }
    ],
    routeTypeMap: [
      { type: 1, routeName: routeINV },
      { type: 2, routeName: routeCN },
      { type: 3, routeName: routePO },
      { type: 4, routeName: routeBL },
      { type: 5, routeName: routeBCN },
      { type: 6, routeName: routeTR },
      { type: 7, routeName: routeAJ },
      { type: 8, routeName: routeInfoPRDC },
      { type: 9, routeName: routeInfoCSR },
      { type: 10, routeName: routeInfoSPL },
      { type: 11, routeName: routeInfoWH },
      { type: 12, routeName: routeInfoBRD },
      { type: 13, routeName: routeInfoEMPL }
    ],
    shipTypes: [
      { value: 1, label: 'Delivery' },
      { value: 6, label: 'Morning Delivery' },
      { value: 7, label: 'Afternoon Delivery' },
      { value: 2, label: 'Pick-up' },
      { value: 3, label: 'Fast Delivery' },
      { value: 8, label: '3rd-Party Logistics' },
      { value: 4, label: 'Driver Pick-up' },
      { value: 5, label: 'Return by CSR' }
    ],
    dlvStatusCode: [
      { value: 0, label: 'Preparing' },
      { value: 1, label: 'Ready' },
      { value: 2, label: 'Delivering' },
      { value: 3, label: 'Finished' },
      { value: 99, label: 'Cancelled' }
    ],
    actualPayCode: [
      { value: 0, label: 'Unpaid' },
      { value: 1, label: 'Cash' },
      { value: 2, label: 'Cheque' },
      { value: 3, label: 'EFT' },
      { value: 4, label: 'POS' },
      { value: 5, label: 'Transfer' },
      { value: 6, label: 'Account Period' },
      { value: 7, label: 'Partial Paid' }
    ],
    billPayCode: [
      { value: 0, label: ' ' },
      { value: 1, label: 'Transfer' },
      { value: 2, label: 'Cash' },
      { value: 3, label: 'POS' },
      { value: 4, label: 'XJK' },
      { value: 5, label: 'Partial' }
    ],
    taxTypes: [
      { value: 1, label: 'No Tax' },
      { value: 2, label: 'Tax Inclusive' },
      { value: 3, label: 'GST on Income' }
    ],
    autoPartsTypes: [
      { value: 1, label: 'Wheel' },
      { value: 2, label: 'Filter' },
      { value: 3, label: 'Oil' },
      { value: 6, label: 'Battery' },
      { value: 4, label: 'Bumper' },
      { value: 5, label: 'Suspension' }
    ]
  },
  getters: {
    currentName: state => state.currentAccount.name,
    currentOrgId: state => state.currentAccount.orgId,
    currentOrgName: state => state.currentAccount.companyName,
    categoriesAll: state => {
      const categories = state.categories.slice()
      categories.unshift({ value: 0, label: 'All' })
      return categories
    },
    brandsAll: state => {
      const brands = state.brands.map(b => ({ value: b.id, label: b.name }))
      brands.unshift({ value: 0, label: 'All' })
      return brands
    },
    autoPartsTypes: state => state.autoPartsTypes,
    brandsNormal: state =>
      state.brands.map(b => ({ value: b.id, label: b.name })),
    stockAvlAll: state => {
      const stockAvl = state.stockAvl.slice()
      stockAvl.unshift({ value: 0, label: 'All' })
      return stockAvl
    },
    warehosuesAll: state => {
      const warehosues = state.warehouses.slice()
      warehosues.unshift({ value: 0, label: 'All' })
      return warehosues
    },
    paymentTypesAll: state => {
      const paymentTypes = state.paymentTypes.slice()
      paymentTypes.unshift({ name: 'All', label: 'All' })
      return paymentTypes
    },
    invoiceTags: state => state.tags.filter(t => t.value !== 5),
    purchaseTags: state =>
      state.tags.filter(t => t.value !== 3 && t.value !== 4),
    getTagName: state => id => {
      const tag = state.tags.find(t => t.value === id) || { label: '' }
      return tag.label
    },
    orderTypeName: state => id => {
      const type = state.orderTypes.find(o => o.value === id) || { label: '' }
      return type.label
    },
    sales: state => state.staff.filter(s => s.role > 1 && s.role < 5), // 2 普商，3资深，4经理
    bd: state => state.staff.filter(s => s.role === 1), // 1=业务员
    drivers: state => state.staff.filter(s => s.role === 6),
    getStaffName: state => id => {
      const staff = state.staff.find(t => t.value === id) || { label: '' }
      return staff.label
    },
    getDriverName: state => id => {
      const staff = state.staff.find(t => t.value === id) || { label: 'not assigned' }
      return staff.label
    },
    getStaffId: state => name => {
      const staff = state.staff.find(t => t.label === name) || { value: '' }
      return staff.value
    },
    getWarehouseName: state => val => {
      const warehouse = state.warehouses.find(w => w.value === val) || {
        lable: ''
      }
      return warehouse.label
    },
    getDrafterTypeName: state => val => {
      const drafterType = state.drafterType.find(d => d.value === val) || {
        lable: ''
      }
      return drafterType.label
    },
    getDrafterTypeColumnName: state => val => {
      const drafterType = state.drafterTypeColumn.find(d => d.value === val) || {
        lable: 'System'
      }
      return drafterType.label
    },
    getShipTypeName: state => val => {
      const shipType = state.shipTypes.find(w => w.value === val) || {
        lable: ''
      }
      return shipType.label
    },
    getDlvStatusName: state => val => {
      const dlvStatus = state.dlvStatusCode.find(w => w.value === val) || { lable: '--' }
      return dlvStatus.label
    },
    getActualPayName: state => id => {
      const pay = state.actualPayCode.find(t => t.value === id) || { label: '--' }
      return pay.label
    },
    getBillPayName: state => id => {
      const pay = state.billPayCode.find(t => t.value === id) || { label: '--' }
      return pay.label
    },
    getOrderTypeFromRouteName: state => name => {
      const map = state.routeTypeMap.find(r => r.routeName === name) || {
        type: 0
      }
      return map.type
    },
    getRouteNameFromOrderType: state => type => {
      const map = state.routeTypeMap.find(r => r.type === type) || {
        routeName: 0
      }
      return map.routeName
    },
    getTaxTypeName: state => type => {
      const tax = state.taxTypes.find(t => t.value === type) || { label: '' }
      return tax.label
    },
    purcahseTaxTypes: state =>
      state.taxTypes.filter(t => t.value === 1 || t.value === 2),
    dateFormatAu: () => date => (date ? moment(date).format('ll') : ''),
    numberFormatAu: () => number =>
      number < 0 ? `(${Math.abs(number)})` : number
  },
  mutations: {
    setAccounts (state, accounts = []) {
      state.accounts.splice(0)
      state.accounts.push(...accounts)
    },
    setPrintInfo (state, info = {}) {
      state.printInfo = info
    },
    switchAccount (state, account) {
      // const account = state.accounts.find(a => a.eId == id)
      state.currentAccount = account
    },
    setBrands (state, brands) {
      state.brands.splice(0)
      state.brands.push(...brands)
    },
    setWarehouses (state, warehouses) {
      state.warehouses.splice(0)
      state.warehouses.push(
        ...warehouses.map(w => ({ value: w.id, label: w.name }))
      )
    },
    setStaff (state, staff) {
      state.staff.splice(0)
      state.staff.push(
        ...staff.map(s => ({
          value: s.id,
          label: s.name,
          role: s.role,
          isActive: s.is_active
        }))
      )
    },
    setAreaTypes (state, areas) {
      state.areaTypes.splice(0)
      state.areaTypes.push(...areas)
    },
    setPaymentTypes (state, payments) {
      state.paymentTypes.splice(0)
      state.paymentTypes.push(...payments)
    },
    setCsrSelfOrderCnt (state, cnt) {
      state.csrSelfOrderCnt = cnt
    }
  },
  actions: {
    async initAccountsAction ({ commit }) {
      const accounts = (await getAccounts()).data
      commit('setAccounts', accounts)
      const localId = Number.parseInt(localStorage.getItem('eId') || 0)

      let account = accounts.find(a => a.eId === localId)
      if (!account) {
        account = accounts[0]
      }
      commit('switchAccount', account)
      localStorage.setItem('eId', account.eId)
      localStorage.setItem('orgId', account.orgId)
      localStorage.setItem('role-fone', account.phone)
      localStorage.setItem('role', account.role)
    },
    switchAccountAction (context, account) {
      context.commit('switchAccount', account)
      localStorage.setItem('eId', account.eId)
      localStorage.setItem('orgId', account.orgId)
      localStorage.setItem('role-fone', account.phone)
      localStorage.setItem('role', account.role)
      context.dispatch('cart/clearCart', null, { root: true })
    },
    async initBrandsAction ({ commit }) {
      const brands = (await getBrands()).data
      commit('setBrands', brands)
    },

    async initWarehousesAction ({ commit }) {
      const warehouses = (await getWarehouses()).data
      commit('setWarehouses', warehouses)
    },

    async initStaffAction ({ commit }) {
      const staff = (await getStaff()).data
      commit('setStaff', staff)
    },
    async initPrintInfoAction ({ commit }) {
      const info = (await getPrintInfo()).data
      commit('setPrintInfo', info)
    },
    async initAreaTypesAction ({ commit }) {
      const areas = await getAreaTypes()
      commit('setAreaTypes', areas)
    },

    async initPaymentTypesAction ({ commit }) {
      const payments = await getPaymentTypes()
      commit('setPaymentTypes', payments)
    },

    async initCsrSelfOrderAction ({ commit }) {
      const data = await getCsrSelfOrderCnt()
      commit('setCsrSelfOrderCnt', data.cnt)
    }
  }
})
